<template>
  <el-popover
    trigger="hover"
    placement="bottom"
    :open-delay="500"
    :disabled="!isShowPop"
  >
    <el-table
      :data="getData(rowData)"
      :show-header="false"
      row-class-name="popover-field"
    >
      <el-table-column
        prop="label"
        :width="labelColW"
        align="left"
      >
        <template slot-scope="scope">
          {{ scope.row.label }}
        </template>
      </el-table-column>
      <el-table-column
        prop="data"
        :width="dataColW"
        align="left"
      >
        <template slot-scope="scope">
          <div
            class="allow-click-copy"
            @click="doCopy(scope.row.data)"
          >
            {{ scope.row.data }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="tool-tip-content">
      <el-tooltip
        class="item"
        effect="dark"
        placement="bottom"
        :open-delay="500"
        :content="$t('api.actions.itemLink.search')"
      >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-search"
          circle
          @click="doSearch(idField, rowData[idField], nameField, rowData[nameField])"
          :disabled="!isAllowSearch"
        >
        </el-button>
      </el-tooltip>
      <el-tooltip
        v-if="basePath"
        class="item"
        effect="dark"
        placement="bottom"
        :open-delay="500"
        :content="$t('api.actions.itemLink.list')"
      >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-menu"
          circle
          @click="$router.push({
          path: basePath + '/list?' + baseIDField + '=' + rowData[idField] + '&date_range=all'
          })"
          :disabled="!isAllowList"
        >
        </el-button>
      </el-tooltip>
    </div>
    <span
      v-if="displayType === 'text'"
      slot="reference"
      v-bind="$attrs"
    >
      <slot name="prepend"></slot>
      {{ getLabel(rowData) }}
      <slot name="append"></slot>
    </span>
    <el-tag
      v-else-if="displayType === 'tag'"
      slot="reference"
      v-bind="$attrs"
      class="no-click tag-list"
    >
      <slot name="prepend"></slot>
      {{ getLabel(rowData) }}
      <slot name="append"></slot>
    </el-tag>
    <el-tag
      v-else-if="displayType === 'tag-link'"
      slot="reference"
      v-bind="$attrs"
      class="tag-list"
      @click="$router.push({
      path: basePath + '/edit/' + rowData[idField]
      })"
    >
      <slot name="prepend"></slot>
      {{ getLabel(rowData) }}
      <slot name="append"></slot>
    </el-tag>
    <el-link
      v-else
      slot="reference"
      v-bind="$attrs"
      @click="$router.push({
      path: basePath + '/edit/' + rowData[idField]
      })"
    >
      <slot name="prepend"></slot>
      {{ getLabel(rowData) }}
      <slot name="append"></slot>
    </el-link>
  </el-popover>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { updateRoute } from '@/utils/route'
import { getLabelText } from '@/utils/i18n'

export default {
  name: 'item-link',
  props: {
    base: {
      type: String,
      required: true
    },
    baseField: {
      type: String,
      default: 'id'
    },
    baseIDField: {
      type: String,
      default: 'id'
    },
    basePath: {
      type: String,
      default: ''
    },
    rowData: {
      type: Object,
      required: true
    },
    displayType: {
      type: String,
      default: 'link'
    },
    labelColW: {
      type: Number,
      default: 80
    },
    dataColW: {
      type: Number,
      default: 150
    },
    isShowPop: {
      type: Boolean,
      default: true
    },
    isAllowSearch: {
      type: Boolean,
      default: true
    },
    isAllowList: {
      type: Boolean,
      default: true
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    idField: {
      type: String,
      default: 'id'
    },
    unhideIDField: {
      type: String,
      default: ''
    },
    nameField: {
      type: String,
      default: 'name'
    },
    customLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    doCopy,
    updateRoute,
    getLabelText,
    getLabel (row) {
      return this.customLabel || row[this.nameField]
    },
    getData (row) {
      let data = [{
        label: this.getLabelText(this.base, this.baseField),
        data: row[this.idField]
      }]
      if (this.unhideIDField && row[this.unhideIDField]) {
        data.push({
          label: this.$t('api.unhideID'),
          data: row[this.unhideIDField]
        })
      }
      for (let i = 0; i < this.fields.length; ++i) {
        let f = this.fields[i]
        data.push({
          label: f.label,
          data: row[f.fname]
        })
      }
      return data
    },
    doSearch (field, q, showName, showValue) {
      this.updateRoute([{
        'field': field,
        'value': q
      }, {
        'field': showName,
        'value': showValue
      }
      ])
    }
  },
  watch: {
  }
}
</script>
